import React, { Component } from "react";
import { Icon, Dropdown, Radio, Button, Pagination } from "semantic-ui-react";
import ReactHtmlParser from "react-html-parser";
import swal from "sweetalert";
import { producaov2 as api } from "../../../../services/apis";
import { dataEnvio } from "../../../../utils/Utils";
import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  LinkRedirect,
  SearchButton,
} from "./styled";
import CursosSelector from "../../../../components/Admin/CursosSelector";


class Duvidas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tutores: [
        { key: 0, value: 0, text: "Todos" },
        { key: 1, value: 48, text: "Thiago Coutinho" },
        { key: 2, value: 7515, text: "Daniel Fraga" },
        { key: 3, value: 18805, text: "Rafael Oliveira" },
        { key: 4, value: 36119, text: "Daniel Voitto" },
        { key: 5, value: 27852, text: "Julio Briales" },
        { key: 6, value: 30879, text: "Raphael Nunes" },
        { key: 7, value: 7522, text: "Victor Paradella" },
        { key: 8, value: 12477, text: "Luana Alvarenga" },
        { key: 9, value: 7516, text: "Carol Portilho" },
        { key: 10, value: 8574, text: "Cintia Ferreira" },
      ],
      prioridades: [
        { key: 1, value: 1, text: "Nível 1", color: "#e9edc9" },
        { key: 2, value: 2, text: "Nível 2", color: "#ffdab9" },
        { key: 3, value: 3, text: "Nível 3", color: "#f5cac3" }
      ],
      tickets: [],
      page: 1,
      page_quant: 0,
      filter: {
        tutor: 0,
        search: "",
        doubtSearch: "",
        status: 0,
        dateStart: "",
        dateEnd: "",
        prioridade: "",
        course: 0
      },
    };
  }

  async componentDidMount() {
    const preSet = {};

    window.location.href.split("?")[1] &&
      window.location.href
        .split("?")[1]
        .split("&")
        .map((link) => {
          preSet[link.split("=")[0]] = link.split("=")[1];
        });

    const { filter } = this.state;
    filter.tutor = preSet.idTutor ? preSet.idTutor : 0;
    filter.status = preSet.status ? parseInt(preSet.status, 10) : 0;

    this.setState({ filter }, () => this.filterTickets());
  }

  handleTutorChange = (e, value, index) => {
    const { tickets } = this.state;

    tickets[index].id_tutor = value;

    api
      .put(
        `admin/operacoes/controle-tickets-update/${tickets[index].id}?${tickets[index].mensagem === "Resposta" ? `isResposta=1` : ""
        }`,
        {
          id_tutor: value,
        }
      )
      .then((res) => {
        let logs = {
          local: "ead/Duvidas",
          texto: `editou o tutor do ticket de id=${tickets[index].id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });
        swal(
          `Tutor alterado com sucesso !`,
          `O tutor desta dúvida foi alterado com sucesso`,
          `success`
        );
      });

    this.setState({ tickets });
  };

  handlePrioridadeChange = (e, value, index) => {
    const { tickets } = this.state;

    tickets[index].prioridade = value;

    api
      .put(
        `admin/operacoes/controle-tickets-update/${tickets[index].id}?${tickets[index].mensagem === "Resposta" ? `isResposta=1` : ""
        }`,
        {
          prioridade: value,
        }
      )
      .then((res) => {
        let logs = {
          local: "ead/Duvidas",
          texto: `editou a prioridade do ticket de id=${tickets[index].id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });
        swal(
          `Prioridade alterada com sucesso !`,
          `A prioridade desta dúvida foi alterada com sucesso`,
          `success`
        );
      });

    this.setState({ tickets });
  };

  handleFilterStatus = (value) => {
    const { filter } = this.state;

    filter.status = value;

    this.setState({ filter }, this.filterTickets);
  };

  handleFilterDateStart = (e) => {
    const { filter } = this.state;

    filter.dateStart = e.target.value;

    this.setState({ filter }, this.filterTickets);
  };

  handleFilterDateEnd = (e) => {
    const { filter } = this.state;

    filter.dateEnd = e.target.value;

    this.setState({ filter }, this.filterTickets);
  };

  handleFilterTutores = (value) => {
    const { filter } = this.state;

    filter.tutor = value;

    this.setState({ filter }, this.filterTickets);
  };

  handleFilterSearch = (e) => {
    const { filter } = this.state;

    filter.search = e.target.value;

    this.setState({ filter });
  };

  handleFilterDoubtSearch = (e) => {
    const { filter } = this.state;

    filter.doubtSearch = e.target.value;

    this.setState({ filter });
  };

  handleCourseChange = (value) => {
    const { filter } = this.state;

    filter.course = value;

    this.setState({ filter });
  }

  handleFilterPrioridade = (value) => {
    const { filter } = this.state;

    filter.prioridade = value;

    this.setState({ filter }, this.filterTickets);
  };


  toggleStatus = async (index) => {
    const { tickets } = this.state;

    api
      .put(
        `admin/operacoes/controle-tickets-update/${tickets[index].id}?${tickets[index].mensagem === "Resposta" ? `isResposta=1` : ""
        }`,
        {
          is_pendente:
            !tickets[index].is_pendente && !tickets[index].is_expirada ? 1 : 0,
          is_expirada: 0,
          is_analise: tickets[index].is_analise,
        }
      )
      .then(() => {
        let logs = {
          local: "ead/Duvidas",
          texto: `editou o status do ticket de id=${tickets[index].id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });
      });

    tickets[index].is_pendente =
      !tickets[index].is_pendente && !tickets[index].is_expirada;
    tickets[index].is_expirada = false;

    this.setState({ tickets });
  };

  toggleStatusAnalyses = async (index) => {
    const { tickets } = this.state;

    tickets[index].is_analise = !tickets[index].is_analise;

    api
      .put(
        `admin/operacoes/controle-tickets-update/${tickets[index].id}?${tickets[index].mensagem === "Resposta" ? `isResposta=1` : ""
        }`,
        {
          is_analise: tickets[index].is_analise,
        }
      )
      .then(() => {
        let logs = {
          local: "ead/Duvidas",
          texto: `editou o status de análise ticket de id=${tickets[index].id}`,
        };
        api.post("system_logs", { acao: JSON.stringify(logs) });
      });

    this.setState({ tickets });
  };

  filterTickets = async (page = 1) => {
    const { filter } = this.state;

    const status =
      filter.status === 1
        ? `&isPendente=1`
        : filter.status === 2
          ? `&isExpirada=1`
          : filter.status === 3
            ? `&isPendente=0&isExpirada=0`
            : ``;

    const tutor = filter.tutor ? `&idTutor=${filter.tutor}` : ``;

    const dateStart = filter.dateStart ? `&dateStart=${filter.dateStart}` : ``;

    const dateEnd = filter.dateEnd ? `&dateEnd=${filter.dateEnd}` : ``;

    const prioridade = filter.prioridade ? `&prioridade=${filter.prioridade}` : ``;

    const courseId = filter.course ? `&idCurso=${filter.course}` : ``;

    const { tickets, page_quant } = (
      await api.get(
        `admin/operacoes/controle-tickets?page=${page}&search=${filter.search}${tutor}${status}${dateStart}${dateEnd}${prioridade}&doubtSearch=${filter.doubtSearch}${courseId}`
      )
    ).data;
    this.setState({ page, tickets, page_quant });
  };

  pageChange = (page) => {
    this.filterTickets(page);
  };

  render() {
    const { tickets, tutores, page, page_quant, filter, prioridades } = this.state;

    return (
      <Container>

        <div style={{ display: "flex", marginBottom: "12px" }}>
          <Dropdown
            placeholder="Status"
            search
            fluid
            selection
            options={[
              { key: 0, value: 0, text: "Todos" },
              { key: 1, value: 1, text: "Em aberto" },
              { key: 2, value: 2, text: "Expirada" },
              { key: 3, value: 3, text: "Respondida" },
            ]}
            onChange={(e, { value }) => this.handleFilterStatus(value)}
            value={filter.status}
          />

          <Dropdown
            placeholder="Tutor"
            search
            fluid
            selection
            options={tutores}
            onChange={(e, { value }) => this.handleFilterTutores(value)}
            value={filter.tutor}
            style={{ marginLeft: "16px" }}
          />

          <Dropdown
            placeholder="Prioridade"
            search
            fluid
            selection
            options={[
              { key: 0, value: "", text: "Prioridade" },
              ...prioridades
            ]
            }
            onChange={(e, { value }) => this.handleFilterPrioridade(value)}
            value={filter.prioridade}
            style={{ marginLeft: "16px" }}
          />
        </div>

        <ContainerInputSearch className="ui fluid left icon input">
          <Input
            type="search"
            placeholder="Procurar por aluno..."
            onKeyDown={(e) => e.keyCode === 13 && this.filterTickets()}
            onChange={(e) => this.handleFilterSearch(e)}
            value={filter.search}
          />
          <Icon name="search icon" />
        </ContainerInputSearch>

        <ContainerInputSearch className="ui fluid left icon input">
          <Input
            type="doubtSearch"
            placeholder="Procurar por termo..."
            onKeyDown={(e) => e.keyCode === 13 && this.filterTickets()}
            onChange={(e) => this.handleFilterDoubtSearch(e)}
            value={filter.doubtSearch}
          />
          <Icon name="search icon" />
        </ContainerInputSearch>

        <CursosSelector noLabel handleChange={this.handleCourseChange} />

        <div style={{ display: "flex", width: "100%" }}>
          <div className="ui fluid" style={{ width: "100%" }}>
            <strong>De:</strong>

            <div className="ui input fluid">
              <input
                type="date"
                onChange={(e) => this.handleFilterDateStart(e)}
                value={filter.dateStart}
              />
            </div>
          </div>

          <div
            className="ui fluid"
            style={{ marginLeft: "16px", width: "100%" }}
          >
            <strong>Até:</strong>

            <div className="ui input fluid">
              <input
                type="date"
                onChange={(e) => this.handleFilterDateEnd(e)}
                value={filter.dateEnd}
              />
            </div>
          </div>
        </div>

        <SearchButton>
          <Button
            id="button-pesquisa"
            color={filter.doubtSearch || filter.search || filter.course ? "orange" : ""}
            onClick={() => this.filterTickets()}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "10px",
            }}
          >
            <Icon
              name="search"
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                marginRight: "5px",
              }}
            ></Icon>
            Consultar
          </Button>
        </SearchButton>

        <div
          style={{
            marginTop: "32px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Pagination
            defaultActivePage={1}
            activePage={page}
            onPageChange={(e, f) => this.pageChange(f.activePage)}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={page_quant}
          />
        </div>

        <div style={{width: "100%", overflow: "auto", padding:"1rem 0 "}}> 
        <SemanticTable size="big" celled >
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell style={{ width: "125px" }}>
                Id
              </SemanticTable.HeaderCell>
              {/* <SemanticTable.HeaderCell>Id_Curso</SemanticTable.HeaderCell> */}
              <SemanticTable.HeaderCell>Aluno</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell style={{ width: "350px" }}>
                Dúvida{" "}
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Tutor </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Data </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Status </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Análise </SemanticTable.HeaderCell>
              {/* <SemanticTable.HeaderCell>Prioridade </SemanticTable.HeaderCell> */}
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {tickets &&
              tickets.map((ticket, index) => {
                const mensagem =
                  ticket.mensagem.split(
                    "<strong>Conteúdo da Mensagem:</strong><br /> "
                  ).length > 1
                    ? ticket.mensagem.split(
                      "<strong>Conteúdo da Mensagem:</strong><br /> "
                    )[1]
                    : ticket.mensagem.split(
                      "<strong>Conteúdo da Mensagem:</strong><br /> "
                    )[0];

                const status = ticket.is_pendente
                  ? "EM ABERTO"
                  : ticket.is_expirada
                    ? "EXPIRADA"
                    : "RESPONDIDA";

                return (
                  <SemanticTable.Row id={ticket.id}>
                    <SemanticTable.Cell>
                      <LinkRedirect
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        target="_blank"
                        to={`/online/tickets/${ticket.id_duvida}`}
                      >
                        <div>{ticket.id}</div>
                        <div>Ver pergunta</div>
                      </LinkRedirect>
                    </SemanticTable.Cell>
                    {/* <SemanticTable.Cell>
                      <LinkRedirect
                        target="_blank"
                        to={`/online/assistir/${ticket.id_curso}`}
                      >
                        {ticket.id_curso}
                      </LinkRedirect>
                    </SemanticTable.Cell> */}
                    <SemanticTable.Cell>
                      <LinkRedirect
                        target="_blank"
                        to={`/admin/alunos/detalhes/${ticket.id_pessoa}`}
                      >
                        {ticket.nome_pessoa}
                      </LinkRedirect>
                    </SemanticTable.Cell>
                    <SemanticTable.Cell
                      style={{
                        fontSize: "12px",
                        maxWidth: "350px",
                        overflow: "hidden",
                      }}
                    >
                      {ReactHtmlParser(mensagem)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <Dropdown
                        placeholder=""
                        search
                        fluid
                        selection
                        options={tutores}
                        onChange={(e, { value }) =>
                          this.handleTutorChange(e, value, index)
                        }
                        value={ticket.id_tutor}
                      />
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {dataEnvio(ticket.data_envio)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <Radio
                        toggle
                        checked={
                          ticket.is_expirada || ticket.is_pendente
                            ? false
                            : true
                        }
                        onClick={() => this.toggleStatus(index)}
                      />
                      <p>{status}</p>
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <Radio
                        toggle
                        checked={ticket.is_analise}
                        onClick={() => this.toggleStatusAnalyses(index)}
                      />
                      ANÁLISE
                    </SemanticTable.Cell>
                    {/* <SemanticTable.Cell>
                      <Dropdown
                        key={ticket.id}
                        placeholder="Prioridade"
                        search
                        fluid
                        selection
                        options={prioridades}
                        style={{
                          backgroundColor: ticket.prioridade ? prioridades[ticket.prioridade - 1].color : null
                        }}
                        onChange={(e, { value }) =>
                          this.handlePrioridadeChange(e, value, index)
                        }
                        value={ticket.prioridade}
                      />
                    </SemanticTable.Cell> */}
                  </SemanticTable.Row>
                );
              })}
          </SemanticTable.Body>
        </SemanticTable>

        </div>

        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Pagination
            defaultActivePage={1}
            activePage={page}
            onPageChange={(e, f) => this.pageChange(f.activePage)}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            totalPages={page_quant}
          />
        </div>
      </Container>
    );
  }
}

export default Duvidas;
